import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, pluck, shareReplay, switchMap, tap, throttleTime } from 'rxjs/operators';
import { catchApiErrorAndRethrow, filterNotNullish } from '@app/core/utils/rxjs';
import { Store, select } from '@ngrx/store';
import * as InputsStore from '@app/shared/store/inputs';
import { environment } from '@app-env/environment';
import { ApiResponse } from '@app/core/models';
import { SiteData } from '@app/models/site-data';

@Injectable({
	providedIn: 'root',
})
export class SiteDataService {
	public readonly lang$ = this._uiState.pipe(select(InputsStore.selectors.selectLanguage), filterNotNullish(), distinctUntilChanged());
	public readonly forceReload$ = new BehaviorSubject(Date.now());

	public readonly siteData$: Observable<Partial<SiteData>> = combineLatest([this.lang$, this.forceReload$.pipe(throttleTime(5000))]).pipe(
		switchMap(([lang, t]) =>
			this._http
				.get<ApiResponse<SiteData>>(environment.API_URL + `site-data`, {
					params: {
						lang,
						t,
					},
				})
				.pipe(
					pluck('data'),
					catchApiErrorAndRethrow(),
					catchError(error => {
						console.log('site-data error', error);
						return of({});
					})
				)
		),
		shareReplay(1)
	);

	constructor(private _uiState: Store<InputsStore.State>, private _http: HttpClient) {}

	public forceReload = () => this.forceReload$.next(Date.now());
}
